export default __webpack_public_path__ + "static/media/landing_bg.dbb0716a.png";